import React, { useState } from 'react';
import { Button } from 'antd';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

import { useSendSms } from 'modules/auth';

import { IUserData } from '..';

interface IProps {
  data: IUserData;
  setData: React.Dispatch<React.SetStateAction<IUserData>>;
}

const LoginStep: React.FC<IProps> = ({ setData, data }) => {
  const t = useTranslations('auth');
  const { mutate, isLoading } = useSendSms();
  const [error, setError] = useState(false);

  const isPhoneValid = data.phone?.length === 13; // +998xxxxxxxxx

  const onSendSms = () => {
    if (isPhoneValid) {
      mutate(data.phone);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <>
      <h2 className="mb-4 text-3xl font-semibold">{t('kirish')}</h2>
      <p className="text-md mb-4 text-gray-800">{t('kirish_desc')}</p>

      <PatternFormat
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onSendSms();
          }
        }}
        format="+998 ## ### ## ##"
        allowEmptyFormatting={true}
        mask=" "
        type="tel"
        value={data.phone?.slice(4) || ''}
        onValueChange={e => {
          setError(true);
          setData(prev => ({ ...prev, phone: `+998${  e.value}` }));
        }}
        placeholder={t('phone_placeholder')}
        className={`!mb-2 !h-11 !rounded-md !border hover:!border-green-500 !p-3 ${
          error ? '!border-red-500' : '!border-transparent'
        } w-full !bg-gray-100 hover:!outline-green-500 focus:!outline-green-500`}
      />

      <Button
        loading={isLoading}
        onClick={onSendSms}
        className="!mt-3 !w-full !rounded-md  !border-none !bg-green-500 !py-5 !text-white"
      >
        {t('kirish')}
      </Button>
    </>
  );
};

export default LoginStep;
